webpackJsonpUpdateBris([57],{

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.InpageSubmission = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataLayer = __webpack_require__(410);

var dataLayer = _interopRequireWildcard(_dataLayer);

var _lodash = __webpack_require__(5);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'InpageSubmission';
var CLS = 'InpageSubmission';
var BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

var InpageSubmission = exports.InpageSubmission = function () {
	function InpageSubmission($el) {
		var _this = this;

		_classCallCheck(this, InpageSubmission);

		// $el is the blk node return by the loadInpageSubmission function
		this.$el = $el;
		this.$queryBlock = $($el);
		this.options = {
			observerConfig: {
				attributes: true,
				childList: true,
				subtree: true
			},
			mappings: _lodash2.default.merge({
				contextdatavalue_PurchaseArea: function contextdatavalue_PurchaseArea(value) {
					return {
						customKey: 'review_product_location',
						customValue: value === 'InStore' ? 'in-store' : 'online'
					};
				},
				hostedauthentication_authenticationemail: false,
				rating: 'rating',
				reviewtext: 'review_text',
				title: 'review_title',
				usernickname: 'review_name'
			}, window.settingBVMappings || {}),
			defaultDataLayer: {
				event: 'review-submited',
				name: _lodash2.default.get(window, 'productDetailsJson.title', '')
			}
		};
		this.windowParse = window.JSON.parse;
		this.customParse = function (text, reviver) {
			var json = _this.windowParse(text, reviver);
			_this.onSubmitedInpage(json);

			return json;
		};
	}

	_createClass(InpageSubmission, [{
		key: 'init',
		value: function init() {
			this.setInpageSubmission();
		}
	}, {
		key: 'setInpageSubmission',
		value: function setInpageSubmission() {
			this.registerEvent();
		}
	}, {
		key: 'registerEvent',
		value: function registerEvent() {
			var _this2 = this;

			if (window.BV) {
				window.BV && window.BV.swat_reviews.on('onCloseInpage', function () {
					window.JSON.parse = _this2.windowParse;
				});

				window.BV && BV.inpage_submission.on('show_form', function () {
					window.JSON.parse = _this2.customParse;
					_this2.$queryBlock.removeClass('d-none');
				});
			}
		}
	}, {
		key: 'onSubmitedInpage',
		value: function onSubmitedInpage(json) {
			var mappings = this.options.mappings;
			var mappingList = Object.keys(mappings);
			var notDataForm = mappingList.find(function (key) {
				return json[key] === undefined;
			});

			if (!notDataForm) {
				var data = mappingList.reduce(function (acc, key) {
					if (mappings[key]) {
						if (_lodash2.default.isFunction(mappings[key])) {
							var _mappings$key = mappings[key](json[key]),
							    customKey = _mappings$key.customKey,
							    customValue = _mappings$key.customValue;

							acc[customKey] = customValue;
						} else {
							acc[mappings[key]] = json[key];
						}
					}
					return acc;
				}, this.options.defaultDataLayer);

				dataLayer.pushReviewSubmited(data);
				window.JSON.parse = this.windowParse;
			}
		}
	}]);

	return InpageSubmission;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var puchCheckoutSteps = exports.puchCheckoutSteps = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(step, option) {
		var pushProducts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
		var form = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
		var datasource, first, dataLayerObj;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
						// and a list of productFieldObjects.
						window.dataLayer = window.dataLayer || [];
						if (form) {
							form.removeAttr('submited');
						}

						datasource = [];

						// defined globally by BE;
						// eslint-disable-next-line no-undef

						if (typeof datalayerDataSource != 'undefined') {
							// defined globally by BE;
							// eslint-disable-next-line no-undef
							datasource = datalayerDataSource || [];
						}

						if (datasource.length > 0) {
							first = datasource[0];
							dataLayerObj = {
								'event': 'checkout',
								'ecommerce': {
									'currencyCode': first.currency,
									'checkout': {
										'actionField': {
											'step': step,
											'option': option
										}
									}
								},
								'eventCallback': function eventCallback() {
									if (url) {
										window.location = window.location.pathname;
										return Promise.resolve();
									}
									if (form) {
										if (!form.attr('submited')) {
											form.submit();
											form.attr('submited', true);
										}

										return Promise.resolve();
									}
									return Promise.resolve();
								}
							};

							if (pushProducts) {
								dataLayerObj.ecommerce.checkout.products = datasource;
							}

							// content grouping
							if (step == 3) {
								dataLayerObj.pageType = 'login';
							}

							if (step == 4) {
								dataLayerObj.pageType = 'delivery';
							}

							window.dataLayer.push(dataLayerObj);
						}

					case 5:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function puchCheckoutSteps(_x5, _x6) {
		return _ref.apply(this, arguments);
	};
}();

var pushEmailsWithPromise = exports.pushEmailsWithPromise = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
		var dataLayerObj;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
						// and a list of productFieldObjects.
						window.dataLayer = window.dataLayer || [];
						dataLayerObj = {
							'event': 'signUp',
							'eventCategory': 'Sign Up',
							'eventAction': 'Email Updates',
							'eventCallback': function eventCallback() {
								return Promise.resolve();
							}
						};

						if (window.userId) {
							dataLayerObj.userId = window.userId;
						}
						window.dataLayer.push(dataLayerObj);

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function pushEmailsWithPromise() {
		return _ref2.apply(this, arguments);
	};
}();

var pushLogin = exports.pushLogin = function () {
	var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(option) {
		var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		var dataLayerObj;
		return regeneratorRuntime.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						window.dataLayer = window.dataLayer || [];
						dataLayerObj = {
							'event': 'login',
							'eventCategory': 'login',
							'eventAction': option,
							'eventCallback': function eventCallback() {
								if (form) {
									form.submit();
									return Promise.resolve();
								}

								return Promise.resolve();
							}
						};

						// content grouping

						dataLayerObj.pageType = 'login';
						window.dataLayer.push(dataLayerObj);

					case 4:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function pushLogin(_x10) {
		return _ref3.apply(this, arguments);
	};
}();

exports.pushCheckoutError = pushCheckoutError;
exports.pushAddToCart = pushAddToCart;
exports.pushProductView = pushProductView;
exports.prepGtmProduct = prepGtmProduct;
exports.pushLoginError = pushLoginError;
exports.pushUserInfo = pushUserInfo;
exports.pushCartItems = pushCartItems;
exports.pushReviewSubmited = pushReviewSubmited;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

function pushCheckoutError(errorMsg) {
	var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	window.dataLayer = window.dataLayer || [];

	if (errorMsg) {
		var dataLayerObj = {
			'event': 'checkout error',
			'text': errorMsg
		};

		// content grouping
		if (step == 3) {
			dataLayerObj.pageType = 'login';
		}

		if (step == 4) {
			dataLayerObj.pageType = 'delivery';
		}

		window.dataLayer.push(dataLayerObj);
	}
}

function pushAddToCart(productObj) {
	var plpDatalayerDataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.
	window.dataLayer = window.dataLayer || [];

	var datasource = [];

	// defined globally by BE;
	// eslint-disable-next-line no-undef
	if (typeof datalayerDataSource != 'undefined') {
		// defined globally by BE;
		// eslint-disable-next-line no-undef
		datasource = datalayerDataSource || [];
	}

	if (plpDatalayerDataSource) {
		datasource = plpDatalayerDataSource;
	}

	var result = datasource.find(function (obj) {
		return obj.code === productObj.code;
	});

	if (result) {
		window.dataLayer.push({
			'event': 'addToCart',
			'ecommerce': {
				'currencyCode': result.currency,
				'add': { // 'add' actionFieldObject measures.
					'products': prepGtmProduct(result, productObj) //  adding a product to a shopping cart.
				}
			}
		});
	}
}

function pushProductView(productObj) {
	var plpDatalayerDataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.
	window.dataLayer = window.dataLayer || [];

	var datasource = [];

	// defined globally by BE;
	// eslint-disable-next-line no-undef
	if (typeof datalayerDataSource != 'undefined') {
		// defined globally by BE;
		// eslint-disable-next-line no-undef
		datasource = datalayerDataSource || [];
	}

	if (plpDatalayerDataSource) {
		datasource = plpDatalayerDataSource;
	}

	var result = datasource.find(function (obj) {
		return obj.code === productObj.code;
	});

	if (result) {
		window.dataLayer.push({
			'pageType': plpDatalayerDataSource ? 'plp' : 'pdp',
			'event': 'productDetail',
			'ecommerce': {
				'currencyCode': result.currency || null,
				'detail': {
					'actionField': { 'list': result.category || null },
					'products': prepGtmProduct(result, productObj)
				}
			}
		});
	}
}

function prepGtmProduct(result, productObj) {
	var data = {
		'name': result.name || null,
		'id': result.id || null,
		'price': result.price || null,
		'brand': result.brand || null,
		'category': result.category || null,
		'variant': result.colour || null,
		'dimension5': productObj.size || null,
		'dimension6': result.stock || null,
		'dimension7': result.priceType || null,
		'dimension10': result.code || null,
		'quantity': productObj.quantity || null
	};

	data['collectionType'] = result.collectionType;

	if (result.collectionType && result.collectionType !== 'no') {
		data['collectionID'] = result.collectionID || null;
		data['collectionName'] = result.collectionName || null;
	}

	return [data];
}

function pushLoginError(errorMsg) {
	window.dataLayer = window.dataLayer || [];

	if (errorMsg) {
		var dataLayerObj = {
			'event': 'login error',
			'text': errorMsg
		};

		dataLayerObj.pageType = 'login';

		window.dataLayer.push(dataLayerObj);
	}
}

function pushUserInfo(email) {
	window.dataLayer = window.dataLayer || [];
	if (email) {
		var dataLayerObj = {
			'event': 'userIdentified',
			'identifier': email
		};
		window.dataLayer.push(dataLayerObj);
	}
}

// Trigger immediately after any item is added to cart to indicate the total contents in the cart
function pushCartItems(cartItems) {
	window.dataLayer = window.dataLayer || [];
	if (cartItems) {
		var dataLayerObj = {
			'event': 'cartItemsPush',
			'cartItems': cartItems
		};
		window.dataLayer.push(dataLayerObj);
	}
}

function pushReviewSubmited(data) {
	window.dataLayer = window.dataLayer || [];
	if (data) {
		window.dataLayer.push(data);
	}
}

/***/ })

});


// WEBPACK FOOTER //
// 1742452116000.blk-inpage-submission-chunk.js